import {
  Component,
  Renderer2,
  ChangeDetectionStrategy,
  inject,
  signal,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { Subscription } from 'rxjs';
export let browserRefresh = false;
import { VersionCheckService } from './core/services/version-check/version-check.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private router = inject(Router);
  private connectionService = inject(ConnectionService);
  private versionCheckService = inject(VersionCheckService);
  private renderer = inject(Renderer2);

  title = 'SimpliEd';
  subscription: Subscription;
  loading;
  isConnected = true;
  readonly noInternetConnection = signal(false);
  constructor() {
    const router = this.router;

    this.loading = true;
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
    });
    this.connectionService.monitor().subscribe((state: ConnectionState) => {
      this.isConnected = state.hasNetworkConnection && state.hasInternetAccess;
      this.noInternetConnection.set(!this.isConnected);
    });
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.versionCheckService.initVersionCheck(environment.versionCheckURL);
  }

  ngAfterViewInit() {
    const loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
  }

  // ngAfterViewInit() {
  //     this.router.events
  //         .subscribe((event) => {
  //             if (event instanceof NavigationStart) {
  //                 this.loading = true;
  //             }
  //             else if (
  //                 event instanceof NavigationEnd ||
  //                 event instanceof NavigationCancel
  //             ) {
  //                 this.loading = false;
  //             }
  //         });
  // }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
